import React from 'react';
import Box from '@mui/material/Box';
import { useAppSelector } from '../../../../../redux/hooks';
import { useTranslation } from 'react-i18next';

// Components
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const Legend: React.FC = () => {

    const { t } = useTranslation();

    const colors = useAppSelector(state => state.theme.colors);
    const selectedFile = useAppSelector((state) => state.fileExplorer.selectedFile);  
    const selectedFolder = useAppSelector((state) => state.fileExplorer.selectedFolder);
    const folderView = useAppSelector((state) => state.fileExplorer.folderView); 

    return (
        <Box sx={{ 
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            height: '3vh',
            width: '100%',
            fontSize: 12, 
            backgroundColor: colors?.legend,
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',        
            color: colors?.text
        }}>

            { folderView === 'row' && 
            
                <>
                    <div style={{ 
                        display: 'flex', 
                        flexDirection: 'row',
                        alignItems: 'center',
                        minWidth: '10%',
                        marginLeft: '2%',  
                    }}>
                        { (selectedFile || selectedFolder) ? 
                        <CheckCircleIcon sx={{ fontSize: 15, color: colors?.legendCheckIcon, marginLeft: 1 }} /> 
                        : <CircleOutlinedIcon sx={{ fontSize: 15, marginLeft: 1 }} />}
                    </div>
                    
                    <Box sx={{ width: '30%' }}>{t('name')}</Box>
                    <Box sx={{ width: '30%', marginLeft: '1%' }}>{t('type')}</Box>
                    <Box sx={{ width: '15%' }}>{t('dateCreated')}</Box>
                    <Box sx={{ width: '15%' }}>{t('dateModified')}</Box>
                </>}

        </Box>
    );
};

export default Legend;